import { Language } from '../app/types/enum';

export function getUrlParams(): UrlParams {
  const url = window.parent.location.search;
  const vaJourney = getUrlParameterByName('ucx', url);
  const journeyId = getUrlParameterByName('journey', url);
  const language = <Language>(
    getUrlParameterByName('setLanguage', url)?.toLowerCase()
  );

  if (vaJourney || journeyId) {
    // Remove params from the URL
    window.parent.history.replaceState(
      window.parent.history.state,
      window.parent.history.state ? window.parent.history.state.title : '',
      removeUrlParams(['ucx', 'journey'], window.location.href)
    );
  }
  return { vaJourney, journeyId, language };
}

function getUrlParameterByName(name: string, sourceURL: string) {
  name = name.replace(/[[]]/g, '\\$&');
  const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
    results = regex.exec(sourceURL);
  if (!results || !results[2]) return null;
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

function removeUrlParams(keys: string[] = [], sourceURL: string) {
  let rtn = sourceURL.split('?')[0],
    param,
    paramsArr = [];
  const queryString =
    sourceURL.indexOf('?') !== -1 ? sourceURL.split('?')[1] : '';
  if (queryString !== '') {
    paramsArr = queryString.split('&');
    for (let i = paramsArr.length - 1; i >= 0; i -= 1) {
      param = paramsArr[i].split('=')[0];
      if (keys.includes(param)) {
        paramsArr.splice(i, 1);
      }
    }
    rtn = rtn + '?' + paramsArr.join('&');
  }
  return rtn;
}
